module.exports = ":host {\n  display: block;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/examples/visible-page-selection/visible-page-selection.component.css
// module id = ./src/app/examples/visible-page-selection/visible-page-selection.component.css
// module chunks = main